export default {"src":"/_next/static/media/Business_deal.b24e3ee6.svg","height":290,"width":292,"blurWidth":0,"blurHeight":0};